export default "__VITE_ASSET__D4EFPlE0__"